export default "__VITE_ASSET__DnZrMa3O__"